<template>
  <div id="dispatchDiv">
    <!-- {{ selectedTripJobs }} -->
    <!-- dataTable.length:{{ dataTable.length }} -->
    <!-- tableReady:{{tableReady}} -->
    <h2 class="ma-2" v-if="dispatchType == 'warehouse'">{{ whsName }}</h2>

    <v-toolbar flat class="pt-3">
      <v-combo
        class="ml-2"
        v-model="curAgent"
        v-if="dispatchType == 'ld-pickup'"
        v-bind="agentCombo"
      ></v-combo>

      <v-combo
        class="ml-2"
        v-model="curWhs"
        v-if="dispatchType == 'warehouse'"
        v-bind="whsCombo"
      ></v-combo>
      <v-date-range-picker
        class="ml-2"
        v-model="etaDateRange"
        label="ETA Date Range"
        v-if="dispatchType == 'warehouse'"
        v-bind="whsCombo"
      ></v-date-range-picker>
      <v-date-range-picker
        class="ml-2"
        v-model="etdDateRange"
        label="ETD Date Range"
        v-if="dispatchType == 'warehouse'"
        v-bind="whsCombo"
      ></v-date-range-picker>
      <v-btn @click="createDataObject()" text>
        <v-icon class="ma-2">mdi-reload</v-icon>
        Refresh
      </v-btn>

      <v-spacer></v-spacer>
      <v-menu v-model="menuModel" top>
        <v-spacer></v-spacer>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" class="ma-2" v-on="on" small right text>
            <v-icon class="pr-2">mdi-email</v-icon>
            Documents
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in letters" :key="index">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- </v-toolbar-items> -->
    </v-toolbar>
    <v-tabs class="mt-n2" dark v-model="activeTab" align-with-title show-arrows>
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab @click="reload()">Calendar</v-tab>

      <v-tab @click="reload()">Table View</v-tab>
      <v-tab
        v-if="
          ((curAgent && serviceDate) ||
            dispatchType == 'warehouse' ||
            selectedTrip) &&
            mapReady
        "
        @click="reload()"
      >
        {{ mapTitle }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-data-calendar
          :eventTemplate="eventTemplate"
          :curDate="serviceDate"
          :data-object="data_object"
          :getQry="getQry"
          :getEventColor="getEventColor"
          :key="calKey"
          :eventClick="eventClick"
          :dayClick="showDate"
          calHeight="67vh"
          defaultType="month"
          :eventType="dispatchType"
          :dateType="sitDate"
          v-if="calendarReady && !activeTab"
          :onDataReceived="onDataReceived"
          :filter="calendarFilter"
          ref="calendar"
        ></v-data-calendar>
      </v-tab-item>
      <v-tab-item>
        <d-table
          v-if="data_object && tableReady && activeTab"
          :data_object="data_object"
          :getFreshData="true"
          :table_title="tableTitle"
          :linkClick="linkClick"
          :link="link"
          :directEdit="false"
          :editable="editable"
          :mobileBreakpoint="'0'"
          :onDataReceived="onDataReceived"
          :coloredFields="coloredFields"
          :getItemColor="getItemColor"
          :itemsPerPage="10"
          :searchableColumns="searchableColumns"
          ref="dTable"
          :noDelete="noDelete"
          :key="tableKey"
          :alwaysUpdate="alwaysUpdate"
          :groupName="groupName"
          :filterTabs="filterTabs"
          :filterCondition="filterCondition"
          :editRow="editRow"
          :addButtonCaption="addButtonCaption"
          :fields_excluded="fieldsExcluded"
          :disabledProperty="disabledProperty"
          :getRowClass="getRowClass"
          :afterSave="afterSave"
          :tableName="tableName"
          :isDraggable="tableDraggable"
          :onRowDragDrop="onRowDragDrop"
          :sortBy="sortBy"
          :customSort="customSort"
          :customSortItems="customSortItems"
          :customFilter="customFilter"
          :toolBarControls="toolBarControls"
          :hasSearch="true"
          :groupBy="groupBy"
          :singleSelect="singleSelect"
        />

        <v-expansion-panels v-model="tripDrawer" flat multiple>
          <v-expansion-panel v-if="tbl && dispatchType == 'warehouse'">
            <v-expansion-panel-header>
              Available Trips
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h3>
                {{
                  !selectedTrip || !selectedTrip.length
                    ? "Select Trip to continue"
                    : selectedTripJobs.length +
                      " jobs on trip " +
                      selectedTrip[0].trip_name
                }}
              </h3>

              <d-table
                :editRow="false"
                addButtonCaption="Add New Trip"
                :data_object="trip_data_object"
                :getFreshData="true"
                :directEdit="false"
                :mobileBreakpoint="'0'"
                :itemsPerPage="15"
                ref="dTripTable"
                :defaultModel="defaultModel"
                :alwaysUpdate="true"
                :fields_excluded="tripFieldsExcluded"
                :singleSelect="true"
                :noDelete="true"
                :key="tripTableKey"
                tableName="whs_trips"
                :coloredFields="coloredFields"
                :getItemColor="getItemColor"
                :afterSave="whsTripAfterSave"
                v-if="tripDrawer"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-tab-item>
      <v-tab-item>
        <div :style="'width:' + mapWidth + 'px'">
          <!-- $route.params.id:{{$route.params.id}} -->
          <v-here-map
            :key="mapKey"
            :onMarkerClick="onMarkerClick"
            :topElementClick="topElementClick"
            :mapHeight="mapHeight - 250"
            :mapData="mapData"
            :mapTitle="mapTitle"
            :legend="mapLegend"
            :onLegendSelection="onLegendSelection"
            ref="hereMap"
            :routing="$route.params.id"
          ></v-here-map>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import DTable from "../components/Table";
import * as fun from "../plugins/common";
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(VueAxios, axios);
export default {
  components: {
    DTable,
    // VDateField: () => import("../components/DateField.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VDateRangePicker: () => import("../components/DateRangePicker.vue"),
    VDataCalendar: () => import("../components/DataCalendar.vue"),
    VHereMap: () => import("../components/HereMap.vue"),
  },
  data() {
    return {
      loading: false,
      activeTab: 0,
      tableTitle: "",
      tripDrawer: [],
      drawerWidth: 500,
      alwaysUpdate: false,
      disabledProperty: "",
      fieldsExcluded: [],
      noDelete: true,
      tripHeaders: [
        // { text: "_id", value: "_id" },
        { text: "ShipmentID", value: "shipment_id" },
        { text: "First Name", value: "first_name" },
        { text: "Last Name", value: "last_name" },
        // { text: "Going To", value: "next_stop" },
      ],
      selectedTripJobs: [],
      tripFields: [
        "_id",
        "color",
        "dest_warehouse",
        "etd",
        "haul_type",
        "orig_warehouse",
        "status",
        "trip_name",
        "trip_type",
        "agent",
        "num_jobs",
      ],
      selectedTrip: null,
      tableName: "",
      mini: false,
      tableKey: 0,
      mapKey: 0,
      editable: [],
      serviceDate: "",
      dispatchDate: null,
      tomorrow: null,
      init: true,
      whsName: "",
      menuModel: 0,
      letters: [],
      getFreshData: true,
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      filterCondition: "",
      defaultEventColor: "#137C15FF",
      data_object: null,
      coloredFields: ["service_type", "status", "color", "trip", "trip_name"],
      serviceTypes: [],
      statuses: [],
      filterTabs: [],
      originalRecords: [],
      searchableColumns: [],
      groupBy: "agent",
      groupName: null,

      dataTable: [],
      agent: [],
      tableDraggable: false,
      singleSelect: false,
      curAgent: "",
      curWhs: {},
      dispatchType: "",
      agentCombo: {
        label: "Agent",
        objName: "agent",
        itemText: "company",
        itemValue: "_id",
        defaultIndex: 0,
        returnObject: true,
      },
      whsCombo: {
        label: "Select Warehouse",
        objName: "warehouse",
        itemText: "warehouse_name",
        itemValue: "_id",
        defaultIndex: 0,
        returnObject: true,
      },
      etaDateRange: null,
      etdDateRange: null,
      tbl: null,
      e1: 1,
      tripTableHeight: 0,
      trip_data_object: null,
      addButtonCaption: "",
      editRow: false,
      defaultTripModel: null,
      tripTableKey: 0,
      calKey: 0,
      tripFieldsExcluded: [],
      afterSave: null,
      objectName: "",
      sitSchedule: [
        {
          text: "Receiving",
          value: "eta",
        },
        {
          text: "Shipping",
          value: "etd",
        },
      ],
      sitDate: "eta",
      dateFrame: null,

      events: [],
      startDate: null,
      endDate: null,
      ignoreQry: false,
      calendarReady: false,
      sortBy: "",
      customSort: null,
      customSortItems: [],
      mapTitle: "",
      mapData: [],
      mapHeight: 0,
      mapWidth: 0,
      contWidth: 0,
      hasMap: false,
      tripJobs: [],
      trips: [],
      tripStatuses: [],
      warehouse: [],
      toolBarControls: [],
      mapLegend: null,
      foreman: [],
      defaultModel: null,
      allowedDrivingHoursPerDay: 8,
      selectionRemoved: false,
      mapReady: false,
      initialSelect: false,
      customFilter: null,
      reordered: null,
      tableReady: false,
    };
  },
  activated() {
    if (this.$root.checkUpdate(this)) {
      this.initComp();
    }
  },
  mounted() {
    this.initComp();
    this.setOnMount();
  },
  methods: {
    refreshMap() {
      this.activeTab = 1;
      this.filterData();
      var that = this;
      setTimeout(function() {
        that.activeTab = 2;
      }, 500);
    },

    setOnMount() {
      var that = this;
      this.$root.$on("initTable", (t) => {
        if (t.tableName == "ld-pickup") {
          that.filterData(that.curAgent);
        }
      });
      this.$root.$on("customBtnClick", (t) => {
        if (t.tbl.tableName == "ld-pickup") {
          if (t.btn == "calculate_stop_order") {
            that.dataTable.forEach((r) => {
              that.createPickupMapData(r);
            });
            that.sortMapData();
          }
          if (t.btn == "calculate_route") {
            t.tbl.customBtnLoading = true;
            var data = {
              waypoints: [],
            };
            that.mapData.forEach((w) => {
              data.waypoints.push(w.pos.lat + "," + w.pos.lng);
            });

            that.calculateRoute(data, (r) => {
              t.tbl.customBtnLoading = false;
              that.mapData = [
                {
                  mapLine: {
                    service: {
                      route: r[0],
                    },
                    color: "#" + fun.randomColor(),
                  },
                  waypoints: that.mapData,
                },
              ];

              that.$root.$emit("mapDataChanged", {
                data: that.mapData,
                legend: that.mapLegend,
                routing: this.$route.params.id,
              });
            });
          }
        }
        if (t.btn == "recalc_route") {
          that.createTripMapData(that.reordered);
        }
      });
      this.$root.$on("itemsDeleted", (t) => {
        if (t.tableName == "trips") {
          t.selected.forEach((trip) => {
            var data = {
              metadata: {
                object_name: "sit_schedule",
                qry: { trip: { _id: trip._id } },
              },
              model: {
                trip: null,
              },
            };
            axios
              .post(this.serverURL + "/update_many", data, {
                withCredentials: true,
              })
              .then((response) => {});
          });
        }
      });
      this.$root.$on("tableItemChanged", (t) => {
        if (!t.tbl.tableName && !t.tbl.objectName) {
          return;
        }

        var curRec = that.dataTable.filter((r) => {
          return r._id == t.item._id;
        })[0];
        that.data_object.object_name = that.data_object.object_name.replace(
          "v_",
          ""
        );
        switch (that.dispatchType) {
          case "ld-pickup":
            this.updateLdPickup(t, curRec);

            break;
          case "warehouse":
            if (!curRec && t.formModel) {
              curRec = t.formModel;
            }
            if (
              (t.tbl.tableName &&
                t.tbl.tableName != "trips" &&
                t.tbl.tableName != "whs_trips") ||
              curRec
            ) {
              this.updateWarehouse(t, curRec);
            } else if (
              (t.tbl.objectName && t.tbl.objectName == "v_trip_no_route") ||
              t.tbl.tableName == "trips" ||
              t.tbl.tableName == "whs_trips"
            ) {
              this.trips.push(t.item);
              this.tripAfterSave(null, t.item);
              this.createDataObject();
            }

            break;
          // case "trips":

          default:
            break;
        }
      });

      // this.$root.$on("tableSelectionChanged", (t) => {})

      this.$root.$on("tableSelectionChanged", (t) => {
        switch (t.tableName) {
          case "warehouse":
            if (!that.selectionRemoved && that.selectedTripJobs.length) {
              if (t.selected.length < that.selectedTripJobs.length) {
                //remove from trip
                var r = that.selectedTripJobs.filter(
                  (e) => !t.selected.includes(e)
                );
                that.selectedTripJobs = t.selected;
                that.updateWarehouse(
                  { item: { trip: null }, tbl: "" },
                  r[0],
                  true
                );
                return;
              }
              t.selected.forEach((r) => {
                if (
                  !that.selectedTripJobs.filter((s) => {
                    return s._id == r._id;
                  }).length
                ) {
                  var msg = that.checkDeliveryDate(that.selectedTrip[0], r);
                  if (msg) {
                    this.$root.$confirm
                      .open("Confirmation", msg, {
                        color: "green",
                      })
                      .then((confirm) => {
                        if (confirm) {
                          that.selectedTripJobs.push(r);
                          // if (!r.trip || t.trip._id != this.selectedTrip[0]._id)
                          this.updateWarehouse(
                            { item: { trip: this.selectedTrip[0] }, tbl: "" },
                            r,
                            true
                          );
                        } else {
                          that.selectionRemoved = true;
                          var indexToRemove = -1;
                          t.selected.forEach((s, i) => {
                            if (s._id == r._id) {
                              indexToRemove = i;
                            }
                          });

                          t.selected.splice(indexToRemove, 1);
                          this.updateWarehouse(
                            { item: { trip: null }, tbl: "" },
                            r,
                            true
                          );
                          //
                        }
                      });
                  } else {
                    if (msg == "") {
                      that.selectedTripJobs.push(r);
                      if (isNaN(parseInt(msg))) {
                        this.updateWarehouse(
                          { item: { trip: this.selectedTrip[0] }, tbl: "" },
                          r,
                          true
                        );
                      }
                    }
                  }
                }
              });
            }
            that.selectionRemoved = false;

            that.selectedTripJobs = t.selected;

            break;
          case "trips":
            if (t.selected.length && !t.selectDelete) {
              that.selectedTrip = t.selected;
            } else {
              that.selectedTrip = null;
            }
            that.createTripMapData();
            break;
          case "whs_trips":
            that.selectedTrip = t.selected;
            that.tbl.select =
              that.selectedTrip && that.selectedTrip.length ? true : false;
            that.tbl.selected = [];

            that.tbl.table.forEach((d) => {
              if (
                t.selected &&
                t.selected.length &&
                d.trip &&
                d.trip._id == t.selected[0]._id
              ) {
                that.initialSelect = true;
                that.tbl.selected.push(d);
              }
            });
            break;
          case "legend_trips":
            break;
          default:
            break;
        }
      });
      this.$root.$on("rowReordered", (t) => {
        if (t.$parent.tableName == "trip_jobs") {
          that.reordered = t.$parent.table;
          that.reordered.forEach((r, i) => {
            r.stop_number = i + 1;
          });
          t.$parent.loading = true;
          that.createTripMapData(that.reordered, function() {
            t.$parent.loading = false;
          });
        }
      });
    },
    calculateRoute(model, fn) {
      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true,
        })
        .then((response) => {
          fn(response.data);
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    updateStopIndex(table) {
      table.forEach((d, i) => {
        // if (byIndex) {
        //   d = i;
        // }
        var id = d._id;

        var model = {
          _id: id,
          stop_order: i,
        };

        var data = {
          metadata: {
            object_name: this.data_object.object_name.replace("v_", ""),
          },
          model: model,
        };
        axios.post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        });
      });
    },
    onRowDragDrop(table, event) {
      // var indexes = [event.oldIndex, event.newIndex];
      this.updateStopIndex(table);
    },
    eventTemplate: function(e, data, obj) {
      var parent = fun.getParentByProperty(obj, "getLocation");
      var eventColor = e.color;
      if (e.customer && e.customer.address) {
        var address = "",
          origin,
          destination,
          ev,
          serviceDate;
        origin = parent.getLocation(e, "pickup");
        destination = parent.getLocation(e, "dropoff");
        if (origin) {
          origin = origin.location.address;
          e.orig_city = origin.city;
          e.orig_state = origin.stateCode;
          address = e.orig_city + ", " + e.orig_state;
        }
        if (destination) {
          destination = destination.location.address;
          e.dest_city = destination.city;
          e.dest_state = destination.stateCode;
          address = e.dest_city + ", " + e.dest_state;
        }
      }
      parent = fun.getParentByProperty(obj, "eventType");
      switch (parent.eventType) {
        case "ld-pickup":
          serviceDate = new Date(e.service_date);
          var statusColor = data.additional_model.itinerary_status.filter(
            (a) => {
              return a.status == e.status;
            }
          );
          if (statusColor.length) {
            eventColor = statusColor[0].color;
          }

          var endTime = serviceDate.addHours(1);
          ev = {
            name: e.shipment_id + " " + address,
            start: serviceDate,
            shipment_id: e.shipment_id,
            first_name: e.first_name,
            last_name: e.last_name,
            agent_id: e.agent_id,
            itinerary: e.itinerary,
            color: eventColor,
            // end: fun.formatDateTime(endTime),
            timed: false,
          };

          return ev;

        case "warehouse":
          if (e[parent.dateType]) {
            serviceDate = new Date(e[parent.dateType]);

            if (serviceDate) {
              try {
                ev = {
                  name: e.shipment_id.toString() + " " + address,
                  start: serviceDate,
                  shipment_id: e.shipment_id,
                  // end: fun.formatDateTime(endTime),
                  timed: false,
                };

                return ev;
              } catch (error) {
                console.log(e);
              }
            }
          }

          break;
        case "trips":
          if (e.etd) {
            serviceDate = new Date(e.etd);
          }
          var name = e.trip_name;
          if (e.orig_warehouse) {
            name += " " + e.orig_warehouse.warehouse_name;
          }
          if (e.origin) {
            name += " " + e.origin;
          }
          if (e.agent) {
            name += " " + e.agent.company;
          }
          if (serviceDate) {
            // eventColor = this.statuses.filter((s) => {
            //   return s.status == e.status;
            // })[0].color;
            ev = {
              name: name,
              start: serviceDate,
              id: e._id,
              // end: fun.formatDateTime(endTime),
              timed: false,
              color: e.color,
            };

            return ev;
          }
          break;
        default:
          break;
      }
    },
    onLegendSelection(selected, map) {
      console.log(selected, map);
      // switch (this.dispatchType) {
      //   case "ld-pickup":
      var innerElement = document.getElementsByClassName("map-inner"),
        len = innerElement !== null ? innerElement.length : 0,
        i = 0;
      // innerElement[0].classList.remove("highlighted");
      for (i; i < len; i++) {
        // innerElement[i].className = "map-inner";
        innerElement[i].classList.remove("highlighted");
      }
      if (selected.length) {
        var className =
          this.dispatchType == "ld-pickup"
            ? selected[0].employee_id
            : selected[0].trip_name.substring(0, 3);
        if (className) {
          var highlighted = document.getElementsByClassName(
            className.replace(" ", "-")
          );
          len = highlighted !== null ? highlighted.length : 0;
          i = 0;
          // innerElement[0].classList.add("highlighted");
          for (i; i < len; i++) {
            highlighted[i].classList.add("highlighted");
          }
        }
      }
    },
    initComp() {
      var that = this;
      this.mapHeight = window.innerHeight - 80;
      this.contWidth =
        window.innerWidth -
        document.getElementsByClassName("left-menu")[0].offsetWidth -
        40;
      this.mapWidth = this.contWidth;
      this.dispatchType = this.$route.params.id;
      this.createTripDataObject();
      this.tableName = this.dispatchType;
      switch (this.dispatchType) {
        case "ld-pickup":
          this.initLDPickUp();

          break;

        case "warehouse":
          this.initWarehouse();
          break;
        case "trips":
          this.initTrip();

          break;
        default:
          break;
      }

      this.tripFieldsExcluded = ["trip_jobs", "color"];
      this.createDataObject();
    },
    initLDPickUp() {
      this.activeTab = 0;
      this.hasMap = false;

      this.mapLegend = {
        data_object: {
          object_name: "employee",
          qry: {
            category: "field_employee",
          },
        },
        getFreshData: true,
        mobileBreakpoint: 0,
        get_table: "all",
        all_records: true,
        table_title: "Foreman",
        tableName: "foreman",
        hasSearch: true,
        fields_included: ["employee_id", "full_name"],
        noTabs: true,
        hideHeader: true,
        singleSelect: true,
        coloredFields: ["employee_id"],
        getItemColor: function(e, slot, item, tableName) {
          // console.log(e, slot, item, tableName);
          return item.color;
        },
        width: 2,
      };

      this.mapData = [];
    },
    initWarehouse(keepTab) {
      if (!keepTab) {
        this.activeTab = 1;
      }

      this.hasMap = true;
      this.mapData = [];
      this.mapTitle = "Delivery Map";
      this.mapLegend = {
        editRow: false,
        addButtonCaption: "Add New Trip",
        data_object: this.trip_data_object,
        getFreshData: true,
        directEdit: false,
        mobileBreakpoint: "0",
        itemsPerPage: "15",
        table_title: "Trips",
        tableName: "legend_trips",
        defaultModel: this.defaultModel,
        alwaysUpdate: true,
        // fields_excluded: "tripFieldsExcluded",
        singleSelect: true,
        noDelete: true,
        // rowClick: this.tripSelected,
        afterSave: this.tripAfterSave,
        fields_included: ["trip_name", "status"],
        hideHeader: true,
        coloredFields: ["trip_name"],
        getItemColor: function(e, slot, item, tableName) {
          // console.log(e, slot, item, tableName);
          return item.color;
        },
        noAlert: true,
        width: 2,
      };
    },
    initTrip() {
      this.activeTab = 0;
      this.hasMap = false;
      this.mapData = [];
      this.mapTitle = "Trip Routing Map";
      this.singleSelect = true;
      this.noDelete = false;
    },
    setUpdatedRoutes() {
      console.log("updated routes");
    },
    topElementClick(data) {
      alert("top element click");
    },

    markerWarehouseClick(data, innerElement, topElement) {
      var that = this;
      var updateRecord = function(d) {
        axios
          .post(that.serverURL + "/add_data", d, {
            withCredentials: true,
          })
          .then((response) => {
            if (!unassign) {
              var tripName = that.trips.filter((t) => {
                return t._id == trip._id;
              });

              topElement.innerHTML = trip.trip_name;
              topElement.style.display = "block";
              topElement.style.backgroundColor = trip.color;

              innerElement.className = "map-inner";
              innerElement.classList.add(trip.trip_name.replace(" ", "-"));
              innerElement.classList.add("highlighted");
              // }
            } else {
              topElement.innerHTML = "";
              topElement.style.display = "none";
              topElement.style.backgroundColor = "";
              innerElement.className = "map-inner";
            }
            // this.filterData();
            // that.updateMapData();
            // this.activeTab = 1;
            // setTimeout((that.activeTab = 2), 500);
          });
      };
      var unassign = false;
      var msg = "";
      var model = {};
      var d = {
        metadata: {
          object_name: "sit_schedule",
        },
      };
      var trip = data.legend.selected[0];
      if (trip && topElement && topElement.innerHTML == trip._id) {
        unassign = true;
      }
      if (data.delivery_date_range && data.delivery_date_range.split("-")[1]) {
        msg = this.checkDeliveryDate(trip, data);
      }

      // msg = "Confirm assigning " + trip.trip_name + " to " + data.label + "?";

      if (unassign) {
        msg = "Confirm unassigning " + data.label + "?";
      }
      if (msg) {
        this.$root.$confirm
          .open("Confirmation", msg, {
            color: "green",
          })
          .then((confirm) => {
            if (confirm) {
              // console.log("assigned");

              model = {
                _id: data.id,
                etd: unassign ? "" : trip.etd,
                trip: unassign
                  ? ""
                  : {
                      _id: trip._id,
                    },
              };
              d.model = model;
              updateRecord(d);
            }
          });
      } else {
        model = {
          _id: data.id,
          etd: trip.etd,
          trip: {
            _id: trip._id,
          },
        };
        d.model = model;
        updateRecord(d);
      }
    },
    markerClickLdPickup(data, innerElement, topElement) {
      var unassign = false;
      var msg = "";
      if (!data.legend || !data.legend.selected.length) {
        if (data.shipment_id) {
          this.$root.addResentTab(data);
        }
      } else {
        if (!data.shipment_id) {
          return;
        }

        if (topElement.innerHTML == data.legend.selected[0].employee_id) {
          unassign = true;
        }
        msg =
          "Confirm assigning " +
          data.legend.selected[0].full_name +
          " to #" +
          data.shipment_id +
          "?";

        if (unassign) {
          msg = "Confirm unassigning #" + data.shipment_id + "?";
        }

        this.$root.$confirm
          .open("Confirmation", msg, {
            color: "green",
          })
          .then((confirm) => {
            if (confirm) {
              // console.log("assigned");
              var d = {
                metadata: {
                  object_name: "schedule",
                },
              };

              var model = {
                _id: data._id,
                foreman: unassign ? "" : data.legend.selected[0]._id,
              };
              d.model = model;
              var curForeman = this.foreman.filter((f) => {
                return f._id == model.foreman;
              });

              axios
                .post(this.serverURL + "/add_data", d, {
                  withCredentials: true,
                })
                .then((response) => {
                  // var innerElement = topElement.parentElement.getElementsByClassName(
                  //   "map-inner"
                  // )[0];
                  if (!unassign) {
                    var employeeId = curForeman[0].employee_id;
                    if (employeeId) {
                      topElement.innerHTML = employeeId;
                      topElement.style.display = "block";
                      topElement.style.backgroundColor = curForeman[0].color;

                      innerElement.className = "map-inner";
                      innerElement.classList.add(employeeId.replace(" ", "-"));
                      innerElement.classList.add("highlighted");
                    }
                  } else {
                    topElement.innerHTML = "";
                    topElement.style.display = "none";
                    topElement.style.backgroundColor = "";
                    innerElement.className = "map-inner";
                  }

                  // if (feedback) {
                  //   feedback(curForeman[0].employee_id);
                  // }
                });
            }
          });
      }
    },
    onMarkerClick(data, e) {
      var topElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];

      switch (this.tableName) {
        case "ld-pickup":
          this.markerClickLdPickup(data, innerElement, topElement);

          break;
        case "warehouse":
          this.markerWarehouseClick(data, innerElement, topElement);
      }
      // console.log(data);
    },
    eventClick(e) {
      console.log(e);
      switch (this.dispatchType) {
        case "trips":
          this.data_object.qry = {
            _id: e.event.id,
          };
          // this.tableKey != this.tableKey;
          this.ignoreQry = true;
          this.activeTab = 1;

          break;

        default:
          this.linkClick(e.event);
          break;
      }
    },
    getEventColor(event) {
      return event.color || this.defaultEventColor;
    },
    updateLdPickup(t, curRec) {
      var that = this;
      var model = {
        _id: t.item._id,
        status: t.item.status,
        foreman: t.item.foreman,
      };

      var data = {
        metadata: that.data_object,
        model: model,
      };
      axios.post(this.serverURL + "/add_data", data, {
        withCredentials: true,
      });

      if (curRec.itinerary && curRec.itinerary.length) {
        var itinerary = curRec.itinerary;
        if (
          itinerary[0].agent._id != t.item.agent._id ||
          itinerary[0].warehouse._id != t.item.warehouse._id
        ) {
          itinerary[0].agent = t.item.agent;
          itinerary[0].warehouse = t.item.warehouse;
          model.itinerary = itinerary;
          model.shipment_id = curRec.shipment_id;
          model.estimate_key = curRec.estimate_key;
          model.service_id = curRec.service_id;

          axios.post(this.serverURL + "/update_itinerary", model, {
            withCredentials: true,
          });
        }
      }
    },
    checkDeliveryDate(trip, curRec) {
      if (!trip) {
        return;
      }
      var msg = "";
      if (trip._id && curRec.trip && curRec.trip._id == trip._id) {
        return 0;
      }
      if (
        curRec.delivery_date_range &&
        new Date(curRec.delivery_date_range.split("-")[1]) < new Date(trip.etd)
      ) {
        msg =
          "Trip " +
          trip.trip_name +
          " departs at " +
          fun.formatDate(trip.etd) +
          ", however the latest delivery date of this shipment is " +
          fun.formatDate(curRec.delivery_date_range.split("-")[1]) +
          ".\nYou still want to assign this trip to the shipment?";
        return msg;
      } else if (curRec.eta && new Date(curRec.eta) > new Date(trip.etd)) {
        msg =
          "Trip " +
          trip.trip_name +
          " departs at " +
          fun.formatDate(trip.etd) +
          ", however the arrival date of this shipment is " +
          fun.formatDate(curRec.eta) +
          ".\nYou still want to assign this trip to the shipment?";
        return msg;
      } else {
        return "";
      }
    },
    updateWarehouse(t, curRec, bulk) {
      var that = this;
      var whs = null;
      var updateRecord = function(data) {
        axios
          .post(that.serverURL + "/add_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            if (!bulk) {
              that.createDataObject();
            } else {
              if (t.item.trip) {
                curRec.trip = {
                  _id: t.item.trip._id,
                };
              } else {
                curRec.trip = null;
              }

              that.selectionRemoved = true;
              that.tbl.tableKey = !that.tbl.tableKey;
              that.selectionRemoved = false;
            }
          });
      };
      if (!curRec) {
        return;
      }
      var model = {};
      if (curRec && curRec.itinerary && curRec.itinerary.length) {
        var itinerary = curRec.itinerary;
        if (curRec.nextItineraryIndex && curRec.nextItineraryIndex > -1) {
          var nextItinerary = itinerary[curRec.nextItineraryIndex];

          nextItinerary = curRec.next_stop;

          model.itinerary = itinerary;
          model.shipment_id = curRec.shipment_id;
          model.estimate_key = curRec.estimate_key || "non-binding";
          model.service_id = curRec.service_id;

          axios.post(this.serverURL + "/update_itinerary", model, {
            withCredentials: true,
          });
        }
      }
      var data = {
        metadata: {
          object_name: "sit_schedule",
          id_fields: ["_id"],
        },
      };

      var trip = null;
      var tripItem = t.item.trip;
      if (t.tbl.tableName == "trips" || t.tbl.objectName == "v_trip_no_route") {
        tripItem = t.item;
      }
      if (tripItem) {
        trip = this.trips.filter((r) => {
          return r._id == tripItem._id;
        })[0];
        if (!trip) {
          trip = tripItem;
          this.trips.push(trip);
        }
        if (nextItinerary) {
          whs = nextItinerary.warehouse;
          if (whs) {
            this.warehouseToTrip(whs, trip);
          }
        }
      }
      model = {
        _id: curRec._id,
        // next_stop: t.item.next_stop,
        eta: fun.formattedDateTime(t.item.eta, "8:00"),
        etd: fun.formattedDateTime(t.item.etd, "8:00"),
      };

      // var newTrip = t.trip || t.item.trip;

      if (trip) {
        if (
          !this.trips.filter((r) => {
            return r._id == trip._id;
          }).length
        ) {
          this.trips.push(trip);
        }
        // else {
        //   newTrip = this.trips.filter((r) => {
        //     return r._id == newTrip._id;
        //   })[0];
        // }
        //assign trip
        if (
          curRec.delivery_date_range &&
          curRec.delivery_date_range.split("-")[1]
        ) {
          var msg = bulk || whs ? "" : this.checkDeliveryDate(trip, curRec);
          if (msg) {
            this.$root.$confirm
              .open("Confirmation", msg, {
                color: "green",
              })
              .then((confirm) => {
                if (confirm) {
                  model.trip = { _id: trip._id };
                  model.etd = fun.formattedDateTime(trip.etd, "8:00");
                  data.model = model;
                  updateRecord(data);
                } else {
                  t.item.trip = curRec.trip;
                }
              });
          } else {
            model.trip = { _id: trip._id };
            model.etd = fun.formattedDateTime(trip.etd, "8:00");
            data.model = model;
            updateRecord(data);
          }
        }
      } else {
        model.trip = null;
        model.etd =
          t.item && t.item.etd ? fun.formattedDateTime(t.item.etd, "8:00") : "";
        // model.delivery_date_range = t.item.delivery_date_range;
        data.model = model;
        updateRecord(data);
      }
    },

    createTripDataObject() {
      this.trip_data_object = {
        object_name: "v_trip_no_route",
        fields: this.tripFields,
        mobileBreakpoint: 0,
        get_table: "all",
        alwaysAddId: true,
        all_records: true,
        additional_data: [
          { obj_name: "warehouse" },
          { obj_name: "trip_status" },
          {
            obj_name: "v_sit_schedule",
            qry: {
              trip: { $ne: null },
            },
          },
        ],

        table_title: "Trips",
        hasSearch: true,
      };
    },

    formatDate(d) {
      return fun.formatDate(d);
    },
    showDate(v) {
      // if (this.dispatchType != "trips") {
      this.serviceDate = new Date(v);
      this.mapTitle = "Pickup Map " + fun.formatDate(this.serviceDate);
      this.getQry(v);
      this.activeTab = 1;
      // }
    },
    reload() {
      return;
    },
    // assignShipmentsToTrip() {
    //   this.selectedTripJobs.forEach((r) => {
    //     this.updateWarehouse(
    //       { item: { trip: this.selectedTrip[0] }, tbl: "" },
    //       r,
    //       true
    //     );
    //   });
    //   this.selectedTripJobs = [];
    //   this.selectedTrip = null;
    //   this.tripDrawer = [];
    // },
    assignToTrip(item) {
      var data = {
        metadata: {
          object_name: "sit_schedule",
          id_fields: ["_id"],
        },
      };
      item.trip_job.forEach((j) => {
        var curRow = this.selectedTripJobs.filter((r) => {
          return r.service_id == j.service_id;
        })[0];

        var model = {
          _id: curRow ? curRow._id : "",
          etd: item.etd,
          trip: {
            _id: item._id,
            trip_name: item.trip_name,
            color: item.color,
          },
        };
        if (curRow) {
          curRow.trip = model.trip;

          data.model = model;
          axios
            .post(this.serverURL + "/add_data", data, {
              withCredentials: true,
            })
            .then((response) => {});
        }
      });

      this.tableKey = !this.tableKey;
      this.mapKey = !this.mapKey;
    },

    tripSelected(item, value) {
      var tripJob = this.getSelectedJobs();
      if (!tripJob.length) {
        this.$root.alertDialog(
          "No Jobs Selected",
          "Please select at least 1 job"
        );

        return;
      }

      this.$root.$confirm
        .open(
          "Confirmation",
          "Confirm adding " + tripJob.length + " job(s) to trip?",
          {
            color: "green",
          }
        )
        .then((confirm) => {
          if (confirm) {
            var tripTable = this.$refs.dTripTable;
            var tripJobs = item.trip_job || [];
            item.trip_job = tripJobs.concat(tripJob);
            tripTable.saveRecord(item);
            this.assignToTrip(item);
            this.tripTableKey = !this.tripTableKey;
            // this.calculateRoute(tripJob, (r) => {

            // });
          }
        });
    },
    whsTripAfterSave() {
      this.tripTableKey = !this.tripTableKey;
      if (this.tbl) {
        this.tbl.select = true;
      }
    },
    updateTrip(item) {
      this.tbl.selected.forEach((r) => {
        r.trip = {
          trip_id: item.item._id,
          trip_name: item.item.trip_name,
        };

        this.tbl.saveRecord(r);
      });
      this.tableKey = !this.tableKey;
    },
    warehouseToTrip(whs, trip) {
      var that = this;
      var sameWhs = [];
      this.dataTable
        .filter((r) => {
          return r.warehouse_id == this.curWhs._id;
        })
        .forEach((r) => {
          var nextItinerary = r.itinerary[r.nextItineraryIndex];
          if (
            nextItinerary.warehouse &&
            nextItinerary.warehouse._id == whs._id
          ) {
            if (!r.trip) {
              r.trip = {
                _id: r._id,
              };
              // if (
              //   r.delivery_date_range &&
              //   new Date(r.delivery_date_range.split("-")[1]) >=
              //     new Date(trip.etd)
              // ) {
              //  //
              // }
              sameWhs.push(r._id);
            }
          }
        });

      if (sameWhs.length) {
        var assignToAllWhs = function() {
          that.filterData(trip, true);
          var etd = trip ? trip.etd : "";

          var data = {
            metadata: {
              object_name: "sit_schedule",
              ids: sameWhs,
            },
            model: {
              trip: {
                _id: trip._id,
              },
            },
          };
          if (etd) {
            data.model.etd = fun.formattedDateTime(etd, "8:00");
          }
          axios
            .post(that.serverURL + "/update_many", data, {
              withCredentials: true,
            })
            .then((response) => {
              if (that.activeTab == 2) {
                that.refreshMap();
              }
            });
        };
        // if (sameWhs.length > 1) {
        var msg =
          "Assign to " +
          sameWhs.length +
          " shipments going to the same warehouse - " +
          whs.warehouse_name +
          "?";
        this.$root.$confirm
          .open("Confirmation", msg, {
            color: "green",
          })
          .then((confirm) => {
            if (confirm) {
              assignToAllWhs();
            }
          });
        // } else {
        //   assignToAllWhs();
        // }
      }
    },
    getSelectedJobs() {
      this.tripJobs = [];
      this.selectedTripJobs.forEach((r) => {
        this.tripJobs.push({
          _id: r._id,
          service_id: r.service_id,
          shipment_id: r.shipment_id,
          estimate_key: r.estimate_key,
          first_name: r.first_name,
          last_name: r.last_name,
          stops: r.stops,
        });
      });
      return this.tripJobs;
    },
    createDataObject() {
      var that = this;
      switch (this.dispatchType) {
        case "ld-pickup":
          this.createLDPickUpObject();
          // this.updateLegend();
          break;
        case "warehouse":
          this.createWarehouseDataObject();
          break;

        case "trips":
          this.editable = ["status"];
          this.data_object = this.trip_data_object;

          this.editRow = true;
          this.addButtonCaption = "Add New Trip";
          // this.fieldsExcluded = this.tripFieldsExcluded;
          this.noDelete = false;
          this.alwaysUpdate = true;
          // this.groupBy = "orig_warehouse";
          // this.groupName = function(g) {
          //   if (g) {
          //     return g.warehouse_name;
          //   }
          // };

          this.afterSave = function() {
            that.$root.updatedTabs.push("/dispatch/warehouse");
          };
          this.getQry();
          break;
        default:
          break;
      }

      // this.updateLegend();
    },
    filterLegend() {
      var hereMap = this.$refs.hereMap;
      if (hereMap) {
        var tbl = hereMap.$refs.legend;
        tbl.model = tbl.table;
        switch (this.dispatchType) {
          case "ld-pickup":
            break;
          case "warehouse":
            tbl.table = tbl.table.filter((r) => {
              return r.orig_warehouse._id == this.curWhs._id;
            });
            break;
          default:
            break;
        }
      }
    },
    getQry(s, e) {
      if (s && e) {
        this.startDate = s;
        this.endDate = e;
      }

      var startDate = s,
        endDate = e;

      if (s && !e) {
        if (!this.activeTab) {
          var start = fun.ignoreTimeZone(new Date(s));

          endDate = new Date();

          endDate.setDate(start.getDate() + 1);
          startDate = start;
          // end = new Date(endDate);
        } else {
          if (this.activeTab && this.dispatchType != "warehouse") {
            // this.serviceDate = v || this.serviceDate;
            var d = fun.ignoreTimeZone(new Date(this.serviceDate));
            this.tomorrow = new Date(d.setDate(d.getDate() + 1));
            startDate = this.serviceDate;
            endDate = this.tomorrow;
          }
        }
      }

      var sDate = "";
      if (this.dispatchType == "trips") {
        if (!this.trip_data_object) {
          this.createTripDataObject();
        }
        this.trip_data_object.object_name = "v_trip_no_route";
        this.data_object = this.trip_data_object;
      }
      if (!this.ignoreQry) {
        this.data_object.qry = {};
      }

      switch (this.dispatchType) {
        case "ld-pickup":
          this.data_object.object_name = "v_schedule";
          this.data_object.fields_excluded = ["route"];
          sDate = "date";

          if (this.curAgent) {
            this.data_object.qry["itinerary.agent._id"] = this.curAgent._id;
          }
          if (startDate && endDate && !this.ignoreQry) {
            this.data_object.qry[sDate] = {
              $gte: fun.formatDate(startDate, true, null, true),
              $lt: fun.formatDate(endDate, true, null, true),
            };
          }
          this.tableReady = true;
          this.calendarReady = true;
          break;
        case "warehouse":
          sDate = this.sitDate;
          if (this.curWhs && this.curWhs._id) {
            this.data_object.qry.warehouse_id = this.curWhs._id;
            this.tableReady = true;
            this.calendarReady = true;
          }

          // this.data_object.qry.etd = {
          //   $gte: new Date().getTime(),
          // };
          break;
        case "trips":
          sDate = "etd";
          this.tableReady = true;
          this.calendarReady = true;

          break;
        default:
          break;
      }

      this.ignoreQry = false;

      this.init = false;
      // this.tableKey = !this.tableKey;

      return this.data_object;
      // this.calKey = !this.calKey;
      // this.serviceDate = this.dispatchDate;
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
    getItemColor(value, field, isItem, tableName) {
      if (field == "service_type") {
        return this.getColor(field, this.serviceTypes, value, isItem);
      }
      if (field == "status") {
        if (!this.tripStatuses.length) {
          this.tripStatuses = this.statuses;
        }
        return this.getColor(
          field,
          tableName == "trips" ? this.tripStatuses : this.statuses,
          value,
          isItem
        );
      }
      if (field == "booked") {
        return value == "Booked" ? "green" : "black";
      }
      if (field == "color") {
        return value;
      }
      if (field == "trip") {
        return this.getColor(field, this.trips, value, isItem, "_id");
      }
      if (field == "trip_name") {
        return this.getColor(field, this.trips, value, isItem);
      }
    },
    getRowClass(item) {
      // if (this.dispatchType == "warehouse") {
      //   if (item.trip) {
      //     var color = this.getTripColor(item.trip)
      //       .substr(0, 7)
      //       .replace("#", "");
      //     return "color-" + color;
      //   } else {
      //     return "";
      //   }
      // }
    },
    getColor(field, obj, value, isItem, fldCompare) {
      if (!value) {
        return "";
      }
      var color = "";
      if (!obj.length) {
        obj = [isItem];
      }
      obj.forEach((s) => {
        if (
          s[field] == value ||
          (fldCompare && s[fldCompare] == value[fldCompare])
        ) {
          if (s.color && s.color.replace) {
            if (!isItem) {
              color = s.color.replace("#", "");
            } else {
              color = s.color;
            }
          } else {
            color = "";
          }
        }
      });
      if (!isItem) {
        return "color-" + color;
      } else {
        return color;
      }
    },

    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach((s) => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              // var classCss = "border: 5px solid " + s.color + ";";

              //   s.color = s.color.replace("#", "");
              //   s.color = "#" + s.color.substring(0, s.color.length - 2);
              // }
              var classCss =
                "background-color:" + s.color + "; color:" + "white";
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    },
    createDataLdPickup(data) {
      var headers = [];
      var date = "";
      if (this.serviceDate) {
        date = " " + fun.formatDate(this.serviceDate);
      }
      this.tableTitle =
        this.dispatchType.toUpperCase().replace("-", " ") + date;
      this.serviceTypes = data.additional_model.service_type;
      this.replaceColor(this.serviceTypes);
      this.statuses = data.additional_model.itinerary_status;
      this.replaceColor(this.statuses);
      this.foreman = data.additional_model.v_foreman;

      delete data.schema.properties.estimate;
      data.schema.properties.service_type = { title: "Service Type" };
      data.schema.properties.service_date = { title: "Date" };
      data.schema.properties.booked = { title: "Booked" };
      data.schema.properties.agent = {
        "v-bind": {
          objName: "agent",
          itemValue: "_id",
          itemText: "company",
          notClearable: true,
          returnObject: true,
        },
        "full-width": true,
        "x-display": "v-combo",
      };
      data.schema.properties.warehouse = {
        "v-bind": {
          objName: "warehouse",
          itemText: "warehouse_name",
          itemValue: "_id",
          returnObject: true,
        },
        "x-display": "v-combo",
        "full-width": true,
      };

      data.schema.properties.stop_order = {};
      data.headers = [];
      // data.groupBy = "agent";
      headers = [
        "shipment_id",
        "service_type",
        "service_date",
        "first_name",
        "last_name",
        "orig_city",
        "orig_state",
        "dest_city",
        "dest_state",
        "status",
        "agent",
        "warehouse",
      ];

      if (this.dispatchType == "ld-pickup") {
        var index = headers.indexOf("service_type");
        if (index !== -1) {
          headers.splice(index, 1);
        }
      }
      headers.forEach((l) => {
        var h = { value: l, text: fun.capitalize(l) };
        data.headers.push(h);
      });

      var combined = [];
      // this.filterData(this.curAgent, tbl);
      data.table = data.table.filter((r) => {
        return r.customer;
      });
      data.table.forEach((r) => {
        r.first_name = r.customer.contact.first_name;
        r.last_name = r.customer.contact.last_name;
        r.service_type = fun.capitalize(r.service_type);
        r.status = r.status || "scheduled";
        if (r.customer.address) {
          var origin = this.getLocation(r, "pickup");
          var destination = this.getLocation(r, "dropoff");
          if (origin) {
            origin = origin.location.address;
            r.orig_city = origin.city;
            r.orig_state = origin.stateCode;
          }
          if (destination) {
            destination = destination.location.address;
            r.dest_city = destination.city;
            r.dest_state = destination.stateCode;
          }
          if (r.itinerary && r.itinerary.length) {
            if (r.itinerary[0].agent) {
              r.agent = r.itinerary[0].agent;
            }
            if (r.itinerary[0].warehouse) {
              r.warehouse = r.itinerary[0].warehouse;
            }
          }
        }
      });
    },
    createLDPickUpObject() {
      this.editable = ["status", "agent", "warehouse", "foreman"];
      this.tableDraggable = true;
      this.sortBy = "stop_order";

      this.data_object = {
        object_name: "v_schedule",
        date_fields: ["date"],
        mobileBreakpoint: 0,

        // add_function: "update_customer_geo",

        id_fields: ["agent_id"],
        get_table: "all",
        additional_data: [
          { obj_name: "service_type" },
          { obj_name: "itinerary_status" },
          { obj_name: "warehouse" },
          { obj_name: "agent" },
          { obj_name: "v_foreman" },
        ],
        aggregate_variables: {},
        item_key: "shipment_id",
        table_title: "Shipments",
        hasSearch: true,
      };
      this.getQry();
    },
    createWarehouseDataObject() {
      var that = this;

      this.editable = [
        "eta",
        "etd",
        // "delivery_date_range",
        "next_stop",
        "trip",
      ];
      this.data_object = {
        object_name: "v_sit_schedule",
        mobileBreakpoint: 0,
        // add_function: "update_customer_geo",
        all_records: true,
        id_fields: ["warehouse_id"],

        additional_data: [
          {
            obj_name: "trip",
            fields: this.tripFields,
          },
          { obj_name: "warehouse" },
          { obj_name: "trip_status" },
        ],

        item_key: "shipment_id",
        table_title: "SIT",
        hasSearch: true,
      };
      this.trip_data_object.qry = {
        status: "scheduled",
        "orig_warehouse._id": this.curWhs._id,
      };
      this.trip_data_object.object_name = "v_trip_no_route";
      this.tripFieldsExcluded = [
        "trip_jobs",
        "color",
        "eta",
        "status",
        "orig_warehouse",
        "origin",
        "destination",
      ];
      // this.groupName = function(g) {
      //   if (g) {
      //     return g.trip_name;
      //   }
      // };

      this.customFilter = function(value, search, item) {
        search = search.toLowerCase();
        var trip =
          item.trip &&
          that.trips.filter((f) => {
            return f._id == item.trip._id;
          })[0];
        var destination =
          item.itinerary &&
          item.nextItineraryIndex &&
          item.itinerary[item.nextItineraryIndex]
            ? item.itinerary[item.nextItineraryIndex]
            : "";
        var whs =
          item.itinerary &&
          item.nextItineraryIndex &&
          item.itinerary[item.nextItineraryIndex] &&
          item.itinerary[item.nextItineraryIndex].warehouse
            ? item.itinerary[item.nextItineraryIndex].warehouse.warehouse_name
            : "";
        return (
          (value != null &&
            search != null &&
            typeof value === "string" &&
            value
              .toString()
              .toLowerCase()
              .indexOf(search) !== -1) ||
          (trip && trip.trip_name.toLowerCase().indexOf(search) !== -1) ||
          (destination &&
            destination.step &&
            destination.step.toLowerCase().indexOf(search) !== -1) ||
          (destination &&
            destination.destination &&
            destination.destination.toLowerCase().indexOf(search) !== -1) ||
          (whs && whs.toLowerCase().indexOf(search) !== -1)
        );
      };

      this.customSortItems = ["eta", "etd", "trip"];
      this.customSort = function(items, index, isDesc) {
        items.sort((a, b) => {
          // if (index[0] == "trip") {
          var s = false;
          switch (index[0]) {
            case "trip":
              var tripNameA = "";
              var tripNameB = "";
              if (a["trip"]) {
                tripNameA = that.trips.filter((t) => {
                  return t._id == a[index]._id;
                })[0].trip_name;
              }
              if (b["trip"]) {
                tripNameB = that.trips.filter((t) => {
                  return t._id == b[index]._id;
                })[0].trip_name;
              }

              if (!isDesc[0]) {
                s = tripNameA
                  .toString()
                  .toLowerCase()
                  .localeCompare(tripNameB.toString().toLowerCase());
              } else {
                s = tripNameB
                  .toString()
                  .toLowerCase()
                  .localeCompare(tripNameA.toString().toLowerCase());
              }
              break;
            case "eta":
            case "etd":
              var dateA = a[index].trim()
                ? new Date(a[index].trim())
                : new Date("1/1/1900");
              var dateB = b[index].trim()
                ? new Date(b[index].trim())
                : new Date("1/1/1900");
              if (!isDesc[0]) {
                s = dateA - dateB;
              } else {
                s = dateB - dateA;
                // a[index].trim() && b[index].trim()
                //   ? new Date(a[index]) - new Date(b[index])
                //   : !a[index].trim();
              }
              break;

            default:
              break;
          }
          return s;
        });
        return items;
      };
      this.getQry();

      this.tripTableKey = !this.tripTableKey;
      if (this.tbl) {
        this.tbl.select =
          this.selectedTrip && this.selectedTrip.length ? true : false;
      }
    },
    // createTripDataObject() {},
    createDataWarehouse(data) {
      var headers = [];
      // this.disabledProperty = "trip";
      data.headers = [];
      if (data.additional_model) {
        this.trips = data.additional_model.trip || [];
        this.tripStatuses = data.additional_model.trip_status;
      }

      headers = [
        // "_id",
        "shipment_id",
        // "warehouse_id",
        "first_name",
        "last_name",
        // "service_date",
        "eta",
        "etd",
        "delivery_date_range",
        "dest_city",
        "dest_state",
        "next_stop",
        "trip",
        // "trip_name",
      ];

      headers.forEach((l) => {
        var h = { value: l, text: fun.capitalize(l) };
        data.headers.push(h);
      });

      this.replaceColor(this.trips);
      data.table.forEach((r) => {
        r.trip_name = "(to trip)";
        if (r.trip && this.trips && this.trips.length) {
          var tripExist = this.trips.filter((t) => {
            return r.trip._id == t._id;
          });
          if (!tripExist.length) {
            r.trip = null;
            // r.trip_name = "(no trips)";
          } else {
            r.trip_name = tripExist[0].trip_name; // for sorting
          }
        }
        if (r.customer) {
          r.first_name = r.customer.contact.first_name;
          r.last_name = r.customer.contact.last_name;
          var destination = this.getLocation(r, "dropoff");
          if (r.customer.address) {
            if (destination) {
              destination = destination.location.address;
              r.dest_city = destination.city;
              r.dest_state = destination.stateCode;
            }
          }
        }
        if (r.eta && r.eta != "None") {
          r.eta = fun.formattedDateTime(r.eta);
        } else {
          r.eta = fun.formattedDateTime(r.service_date);
        }

        r.etd = fun.formattedDateTime(r.etd);
        if (r.itinerary && r.itinerary.length) {
          this.getNextStop(r);
          // var itInd = -1;
          // r.itinerary.forEach((i, ind) => {
          //   if (i.warehouse && i.warehouse._id == r.warehouse_id) {
          //     itInd = ind;
          //   }
          // });
          // if (
          //   itInd != -1 &&
          //   r.itinerary[itInd + 1]
          //   // &&
          //   // r.itinerary[itInd + 1].warehouse
          // ) {
          //   r.next_stop = r.itinerary[itInd + 1];
          // }
          // r.nextItineraryIndex = itInd + 1;
          this.createWarehouseMapData(r);
        }
      });
    },
    getNextStop(r) {
      if (r.itinerary && r.itinerary.length) {
        var itInd = -1;
        r.itinerary.forEach((i, ind) => {
          if (i.warehouse && i.warehouse._id == r.warehouse_id) {
            itInd = ind;
          }
        });
        if (
          itInd != -1 &&
          r.itinerary[itInd + 1]
          // &&
          // r.itinerary[itInd + 1].warehouse
        ) {
          r.next_stop = r.itinerary[itInd + 1];
        }
        r.nextItineraryIndex = itInd + 1;
      }
    },
    createDataTrip(data) {
      console.log(data.table);
      this.statuses = data.additional_model.trip_status;
      this.tripJobs = data.additional_model.v_sit_schedule;
      this.filterTabs = [];
      this.statuses.forEach((s) => {
        this.filterTabs.push({
          caption: fun.capitalize(s.status),
          name: "status",
          value: s.status,
          color: s.color,
        });
      });
      this.filterCondition = "";

      data.table.forEach((r) => {
        switch (r.trip_type) {
          case "d2w":
            break;
          case "w2w":
          case "w2d":
            r.origin = "warehouse: " + r.orig_warehouse.warehouse_name;

            break;

          case "d2d":
            break;
          default:
            break;
        }
      });
    },
    onDataReceived(data, tbl) {
      var that = this;
      if (data.model && data.model.length) {
        data.table = data.model;
      }
      if (!data.table) {
        return [];
      }
      if (data.additional_model) {
        this.warehouse = data.additional_model.warehouse;
        this.agent = data.additional_model.agent;
      }

      var headers = [];
      this.mapData = [];

      switch (this.dispatchType) {
        case "ld-pickup":
          this.createDataLdPickup(data);
          break;
        case "warehouse":
          this.createDataWarehouse(data);

          break;

        case "trips":
          this.createDataTrip(data);

          break;
      }

      this.dataTable = data.table;
      this.tbl = this.$refs.dTable;
      this.getLetters();
      return data;
    },
    getLetters() {
      var letterData = {
        object_name: "document",
        qry: {
          category: this.data_object.object_name,
        },
      };

      axios
        .post(this.serverURL + "/get_data", letterData, {
          withCredentials: true,
        })
        .then((response) => {
          this.letters = [];
          if (response.data.model) {
            response.data.model.forEach((l) => {
              this.letters.push({
                text: l.document_name,
              });
            });
          }
        });
    },
    getLocation(r, stopType) {
      var stops = r.stops;
      var st = stops.filter((s) => {
        return s.value == stopType;
      })[0];
      if (st) {
        var location = r.customer.address.filter((a) => {
          return a.full_address == st.full_address;
        })[0];
        if (location && location.location.address.geo) {
          location = location.location.address.geo;
        }
        return location;
      }
    },
    findSequence() {
      var stopsData = [];
      switch (this.dispatchType) {
        case "ld-pickup":
          var i = 1;
          this.mapData.forEach((m) => {
            var stopType = "end";
            if (!m.warehouseId) {
              stopType = "destination" + i;
              i += 1;
            } else {
              if (stopType == "end") {
                stopType + "=" + m.label + ";" + m.pos.lat + "," + m.pos.lng;
                stopsData.push(d);
                stopType = "start";
                stopType + "=" + m.label + ";" + m.pos.lat + "," + m.pos.lng;
                stopsData.push(d);
              }
            }
            var d =
              stopType + "=" + m.label + ";" + m.pos.lat + "," + m.pos.lng;
            stopsData.push(d);
          });

          // var date = new Date(this.serviceDate);
          // stopsData.push("departure=" + date);
          break;

        case "warehouse":
          break;
        case "trips":
          break;
        default:
          break;
      }

      stopsData.push("improveFor=time");
      stopsData.push("mode=fastest;truck;traffic:disabled");
      var data = { data: stopsData.join("&") };
      axios
        .post(this.serverURL + "/find_sequence", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((reason) => {
          console.log(reason);
        });
      // return stopsData;
    },
    getTripRoute(trip, feedback) {
      axios
        .post(
          this.serverURL + "/get_data",
          { object_name: "trip", qry: { _id: trip._id } },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          var data = response.data;
          feedback(data.model[0].route);
        });
    },
    createTripMapData(reorder, feedback) {
      var that = this;
      that.mapData = [];

      if (!this.selectedTrip || !this.selectedTrip.length) {
        return;
      }
      var curTrip = this.selectedTrip[0];
      this.getTripRoute(curTrip, (route) => {
        curTrip.route = route;

        var whs;
        var tripJob = that.tripJobs.filter((t) => {
          return t.trip._id == curTrip._id;
        });

        // tripJob.forEach
        if (curTrip.orig_warehouse) {
          whs = this.warehouse.filter((w) => {
            return w._id == curTrip.orig_warehouse._id;
          });
          if (whs.length) {
            if (whs[0].geo && whs[0].address) {
              this.mapData.push({
                pos: {
                  lat: whs[0].geo.position[0],
                  lng: whs[0].geo.position[1],
                },
                label: whs[0].warehouse_name,
                address: whs[0].address.address,
                shortLabel: '<div class="mdi mdi-forklift"></div>',
                markerColor: whs[0].color,
                warehouseId: whs[0]._id,
                extraClass: ["square"],
              });
            }
          }
        }
        // curTrip.route = null;
        if (reorder) {
          curTrip.route = null;
        }

        if (!curTrip.route) {
          if (!reorder) {
            tripJob.forEach((j, i) => {
              var stops = j.stops;
              var label =
                j.first_name + " " + j.last_name + " #" + j.shipment_id;
              var addr;
              this.getNextStop(j);
              if (j.next_stop && j.next_stop.warehouse) {
                var curWhs = this.warehouse.filter((w) => {
                  return w._id == j.next_stop.warehouse._id;
                });
                if (curWhs.length) {
                  var samePoint = this.mapData.filter((m) => {
                    return (
                      m.pos.lat == curWhs[0].geo.position[0] &&
                      m.pos.lng == curWhs[0].geo.position[1]
                    );
                  });
                  if (!samePoint.length) {
                    this.mapData.push({
                      pos: {
                        lat: curWhs[0].geo.position[0],
                        lng: curWhs[0].geo.position[1],
                      },
                      label: label,
                      address: curWhs[0].address.address,
                      shortLabel: '<div class="mdi forklift"></div>',

                      _id: j._id,
                      service_id: j.service_id,
                      markerColor: this.getTripColor(curTrip) || "",
                    });
                  } else {
                    samePoint[0].label += "; \n" + label;
                  }
                }
              } else {
                stops.forEach((a) => {
                  if (a.address_type == "destination") {
                    addr = a;

                    // if (!samePoint.length) {
                    this.mapData.push({
                      pos: {
                        lat: a.location.address.geo.location.position[0],
                        lng: a.location.address.geo.location.position[1],
                      },
                      label: label,
                      address: a.location.address.address,
                      shortLabel: '<div class="mdi mdi-home-circle"></div>',

                      _id: j._id,
                      service_id: j.service_id,
                      markerColor: this.getTripColor(curTrip) || "",
                    });
                    // }
                  }
                });
                j.address = addr;
                j.full_address = addr.full_address;
              }
            });
          }

          var firstStop = whs[0];
          firstStop.pos = {
            lat: firstStop.geo.position[0],
            lng: firstStop.geo.position[1],
          };

          if (!reorder) {
            this.mapData = this.getSequence(this.mapData, whs[0]);
          } else {
            reorder.unshift(this.mapData[0]);
          }

          this.calculateTripRoute(reorder, function() {
            that.prepareTripLegend(curTrip, tripJob);
            if (feedback) {
              feedback();
            }
          });
        } else {
          this.mapData = curTrip.route;
          that.prepareTripLegend(curTrip, tripJob);
        }
      });
    },
    prepareTripLegend(curTrip, tripJob) {
      this.getTripsMapData(
        this.prepareTripWaypoints(
          curTrip,
          fun.clone(this.mapData[0].waypoints),
          tripJob,
          this.mapData[0].mapLine.service.route.leg
        ),
        {
          stop_number: {
            title: " ",
          },

          delivery_date_range: {
            title: "Del. Range",
          },
          eta: {},
          label: {
            title: "Customer",
          },
          driving_time: {
            title: "Drv. Time",
          },
          mileage: {},
        }
      );
      this.mapReady = true;
      this.$root.$emit("mapDataChanged", {
        data: this.mapData,
        legend: this.mapLegend,
        routing: this.$route.params.id,
      });
    },
    calculateETA(start, drivingTime) {
      // console.log(start, drivingTime);
      var end = start.addHours(parseFloat(drivingTime));
      end = end.addHours(1);
      return end;
    },
    prepareTripWaypoints(trip, mapData, tripJob, leg) {
      var start = new Date(trip.etd);
      if (!start.getHours()) {
        start = start.addHours(8);
      }
      var startTime = start;

      mapData.forEach((d, i) => {
        d.stop_number = i;
        if (i > 0) {
          var drivingTime = (leg[i - 1].travelTime / 3600).toFixed(2);
          var eta = this.calculateETA(startTime, drivingTime);
          if (tripJob.length && tripJob[i - 1]) {
            d.delivery_date_range = tripJob[i - 1].delivery_date_range;
          }

          d.mileage = (leg[i - 1].length / 1.6 / 1000).toFixed(2);
          d.driving_time = drivingTime;
          d.eta = fun.formatDate(eta, false, true);
          startTime = eta;
        }
      });

      mapData.splice(0, 1);
      return mapData;
    },
    getTripsMapData(editData, properties) {
      this.mapLegend = {
        getFreshData: false,
        mobileBreakpoint: 0,
        get_table: "all",
        all_records: true,
        table_title: "Trips Jobs",
        tableName: "trip_jobs",
        hasSearch: false,
        isDraggable: true,
        // headers: ["shipment_id"],
        editData: editData,
        data_object: {
          schema: {
            properties: properties,
          },
        },

        hideHeader: false,
        singleSelect: false,
        width: 4,
        disablePagination: true,
        // toolBarControls: [
        //   {
        //     comp: "v-btn",
        //     id: "recalc_route",
        //     "v-bind": {
        //       color: "info",
        //       text: true,
        //       icon: "mdi-directions",
        //       "input-value": "Recalculate Route",
        //     },
        //   },
        // ],

        // coloredFields: ["employee_id"],
        // getItemColor: function(e, slot, item, tableName) {
        //   // console.log(e, slot, item, tableName);
        //   return item.color;
        // },
      };
    },
    calculateTripRoute(reorder, feedback) {
      var that = this;
      if (!that.selectedTrip.length) {
        return;
      }
      var data = {
        waypoints: [],
      };
      var mapData = that.mapData;

      if (reorder) {
        mapData = reorder;
      }
      mapData.forEach((w, i) => {
        data.waypoints.push(w.pos.lat + "," + w.pos.lng);
        if (i > 0) {
          w.shortLabel = i;
          w.color = that.mapData[0].markerColor;
        }
      });

      that.calculateRoute(data, (r) => {
        // t.tbl.customBtnLoading = false;
        that.mapData = [
          {
            mapLine: {
              service: {
                route: r[0],
              },
              color: mapData[0].markerColor,
            },
            waypoints: mapData,
          },
        ];
        var data = {
          metadata: {
            object_name: "trip",
          },
          model: {
            _id: that.selectedTrip[0]._id,
            route: that.mapData,
          },
        };

        axios
          .post(this.serverURL + "/add_data", data, {
            withCredentials: true,
          })

          .then((response) => {
            if (reorder) {
              that.createDataObject();
            }
          });

        feedback();
      });
    },
    getTripColor(r) {
      try {
        return this.trips.filter((t) => {
          return r._id == t._id;
        })[0].color;
      } catch (error) {
        return "";
      }
    },
    getWarehouseMarker(r, whsFrom, trip) {
      var whsId = r.warehouse_id;
      if (r.next_stop && !whsFrom) {
        whsId = r.next_stop.warehouse._id;
      }
      var whs = this.warehouse.filter((w) => {
        return w._id == whsId;
      });
      if (
        whs.length &&
        !this.mapData.filter((m) => {
          return m.label == whs[0].warehouse_name;
        }).length
      ) {
        var whsColor = whs[0].color;
        var borderColor = "";
        var tripColor = "";
        if (whs[0].geo && whs[0].address) {
          if (
            parseFloat(whs[0].geo.position[0]) &&
            parseFloat(whs[0].geo.position[1])
          ) {
            if (r.trip) {
              var topElementValue = "";
              var topElementColor = "";
              var curTrip = this.trips.filter((t) => {
                return t._id == r.trip._id;
              })[0];
              if (!curTrip || !curTrip.trip_name) {
                curTrip = trip;
              }
              if (curTrip) {
                if (whs[0]._id != r.warehouse_id) {
                  // topElementValue = curTrip.trip_name.substring(0, 5);
                  // topElementColor = curTrip.color;
                  // whsColor = curTrip.color;
                  tripColor = curTrip.color;
                }
              }
            }
          }
          this.mapData.push({
            pos: {
              lat: whs[0].geo.position[0],
              lng: whs[0].geo.position[1],
            },
            label: whs[0].warehouse_name,
            address: whs[0].address.address,
            shortLabel: '<div class="mdi mdi-forklift"></div>',
            warehouseId: whs[0]._id,
            markerColor: whsColor,
            // color: curTrip ? tripColor : "white",
            extraClass: whsFrom
              ? ["square-selected"]
              : curTrip
              ? ["romb"]
              : ["square"],
            topElementValue: topElementValue,
            topElementColor: topElementColor,
            id: !whsFrom ? r._id : "",
          });
        }
      }
    },
    createWarehouseMapData(r, trip) {
      this.getWarehouseMarker(r, true, trip);

      if (r && r.stops && r.next_stop) {
        if (r.next_stop.step == "w2d") {
          var location = this.getLocation(r, "dropoff");
          if (location) {
            var pos = location.location.position;

            if (pos && parseFloat(pos[0]) && parseFloat(pos[1])) {
              var label =
                r.first_name + " " + r.last_name + " #" + r.shipment_id;
              if (r.delivery_date_range) {
                label += "\nDelivery Dates: " + r.delivery_date_range;
              }
              var shortLabel = '<div class="mdi mdi-home-circle"></div>';
              var markerColor = "green";
              var color = "white";
              var trip_id;
              var topElementValue = "";
              var topElementColor = "";
              if (r.trip) {
                trip_id = r.trip._id;
                var curTrip = this.trips.filter((t) => {
                  return t._id == r.trip._id;
                })[0];
                if (!curTrip) {
                  curTrip = trip;
                } else {
                  markerColor = curTrip.color;
                  topElementValue = curTrip.trip_name.substring(0, 3);
                  topElementColor = curTrip.color;
                }
              }
              this.mapData.push({
                pos: {
                  lat: pos[0],
                  lng: pos[1],
                },
                label:
                  label +
                  "\n" +
                  location.location.address.city +
                  ", " +
                  location.location.address.stateCode,
                address: location.location.address.label,
                shortLabel: shortLabel,
                markerColor: markerColor,
                delivery_date_range: r.delivery_date_range,
                color: color,
                id: r._id,
                trip_id: trip_id,
                topElementValue: topElementValue,
                topElementColor: topElementColor,
                extraClass: topElementValue ? ["romb"] : [],
              });
            }
          }
        }
        if (r.next_stop.step == "w2w") {
          // console.log(r);
          this.getWarehouseMarker(r, false, trip);
        }
      }
    },
    tripAfterSave(d, model) {
      // console.log(d);
      if (model.trip_type == "w2w") {
        if (model.dest_warehouse) {
          this.warehouseToTrip(model.dest_warehouse, {
            _id: model._id,
            trip_name: model.trip_name,
            color: model.color,
            etd: model.etd,
          });
        }
      }
      this.updateLegend();
      this.getTripDefaultModel();
      if (this.activeTab == 2) {
        this.refreshMap();
      }
    },
    updateLegend() {
      var hereMap = this.$refs.hereMap;
      if (hereMap) {
        hereMap.legendKey = !hereMap.legendKey;
      }
    },
    createPickupMapData(r) {
      if (r.warehouse) {
        var whs = this.warehouse.filter((w) => {
          return w._id == r.warehouse._id;
        });
        if (
          whs.length &&
          !this.mapData.filter((m) => {
            return m.label == whs[0].warehouse_name;
          }).length
        ) {
          if (whs[0].geo && whs[0].address) {
            if (
              parseFloat(whs[0].geo.position[0]) &&
              parseFloat(whs[0].geo.position[1])
            )
              this.mapData.push({
                pos: {
                  lat: whs[0].geo.position[0],
                  lng: whs[0].geo.position[1],
                },
                label: whs[0].warehouse_name,
                address: whs[0].address.address,
                shortLabel:
                  // r.stop_order
                  // != undefined
                  //   ? r.stop_order
                  //   :
                  '<div class="mdi mdi-forklift"></div>',
                warehouseId: whs[0]._id,
                markerColor: whs[0].color,
                extraClass: ["square"],
              });
          }
        }
      }
      if (r && r.stops) {
        var location = r.stops.filter((s) => {
          return s.address_type == "origin";
        });
        if (location.length) {
          var topElementValue = "";
          var topElementColor = "";
          var orig = location[0];
          var path = ["location", "address", "geo", "location", "position"];
          var pos = fun.getObjectByPath(orig, path);
          if (pos && parseFloat(pos[0]) && parseFloat(pos[1])) {
            var label = r.first_name + " " + r.last_name + " #" + r.shipment_id;
            if (r.delivery_date_range) {
              label += "<br>Delivery Dates:<br>" + r.delivery_date_range;
            }
            var time = fun.formatTime(r.date, true);
            var shortLabel = time;
            if (r.foreman) {
              var curForeman = this.foreman.filter((f) => {
                return f._id == r.foreman;
              });
              if (curForeman[0]) {
                topElementValue = curForeman[0].employee_id;
                topElementColor = curForeman[0].color;
              }
            }

            // r.stop_order != undefined
            //   ? r.stop_order
            //   :

            // '<div class="mdi mdi-home-circle"></div>';
            var markerColor = whs && whs[0] ? whs[0].color : "green";
            var color = "white";

            this.mapData.push({
              pos: {
                lat: pos[0],
                lng: pos[1],
              },
              whs: r.warehouse,
              label: label,
              address: orig.full_address,
              shortLabel: shortLabel,
              markerColor: markerColor,
              color: color,
              shipment_id: r.shipment_id,
              first_name: r.first_name,
              last_name: r.last_name,
              topElementValue: topElementValue,
              topElementColor: topElementColor,

              _id: r._id,
            });
          }
        }
      }
      // console.log(this.mapData);
    },
    dateFilter(type) {
      var tbl = this.$refs.dTable;
      tbl.table = tbl.originalRecords;
      var dr = type == "eta" ? this.etaDateRange : this.etdDateRange;
      var minDate = dr.split("-")[0];
      var maxDate = dr.split("-")[1];
      if (minDate) {
        minDate = new Date(minDate);
      }
      if (maxDate) {
        maxDate = new Date(maxDate);
      }
      var filteredTable = tbl.table.filter((r) => {
        var d = type == "eta" ? r.eta : r.etd;
        if (d) {
          d = new Date(d);
          if (minDate && maxDate) {
            return d >= minDate && d <= maxDate;
          } else {
            return d >= minDate;
          }
        }
      });
      tbl.table = filteredTable;
      // console.log(tbl.table);
    },
    legendFilter(r) {
      if (r.orig_warehouse) {
        return r.orig_warehouse._id == this.curWhs._id;
      } else {
        var trip = this.trips.filter((t) => {
          return t._id == r._id;
        })[0];
        return (
          trip &&
          trip.orig_warehouse &&
          trip.orig_warehouse._id == this.curWhs._id &&
          trip.status == "scheduled"
        );
      }
    },
    filterData(v, noUpdate) {
      var that = this;

      var filteredData = fun.clone(this.dataTable);

      switch (this.dispatchType) {
        case "ld-pickup":
          if (this.$refs.calendar) {
            this.$refs.calendar.events = this.$refs.calendar.originalEvents.filter(
              (e) => {
                return !e.itinerary
                  ? false
                  : v
                  ? e.itinerary &&
                    e.itinerary.length &&
                    e.itinerary[0].agent &&
                    e.itinerary[0].agent._id == v._id
                  : true;
              }
            );
          }
          filteredData = filteredData.filter((e) => {
            return v
              ? e.itinerary &&
                  e.itinerary.length &&
                  e.itinerary[0].agent &&
                  e.itinerary[0].agent._id == v._id
              : true;
          });
          if (this.tbl && this.tbl.originalRecords) {
            this.tbl.table = filteredData;
            this.tbl.hideToolBar(true);
            if (this.curAgent && this.serviceDate) {
              // this.updateStopIndex(filteredData);
              this.tbl.hideToolBar(false);
              // this.$refs.dTable.toolBarControls = this.toolBarControls;
            }

            if (this.curAgent && this.serviceDate) {
              this.tbl.computedHeaders.push({
                text: "Foreman",
                value: "foreman",
              });
            }
          }
          this.mapData = [];

          filteredData.forEach((r) => {
            this.createPickupMapData(r);
          });
          this.mapReady = true;

          break;

        case "warehouse":
          if (this.dispatchType == "warehouse" && !noUpdate) {
            this.createDataObject();
          }

          // this.createTripDataObject();

          if (this.curWhs && this.curWhs._id && !noUpdate) {
            this.whsName = this.curWhs.warehouse_name;
            // this.tableKey = !this.tableKey;
            if (this.dispatchType == "warehouse") {
              this.calKey = !this.calKey;
              if (this.dataTable) {
                this.tableKey = !this.tableKey;
              }
            }
          }
          if (!noUpdate) {
            this.mapData = [];
            this.mapReady = false;

            filteredData.forEach((r) => {
              this.createWarehouseMapData(r, v);
            });

            this.mapReady = true;
          }

          break;
        default:
          break;
      }
      if (!noUpdate) {
        this.updateMapData();
      }
    },
    updateMapData() {
      var that = this;
      setTimeout(function() {
        that.$root.$emit("mapDataChanged", {
          data: that.mapData,
          legend: that.legend,
          filter: that.legendFilter,
          routing: that.$route.params.id,
        });
      }, 500);
    },
    getSequence(data, firstStop, filter) {
      // var mileage = 10000;
      var filtered = data;
      if (filter) {
        filtered = data.filter((r) => {
          return eval(filter);
        });
      }
      filtered.forEach((d) => {
        if (d.pos) {
          d.mileage = fun.mileage(
            firstStop.pos.lat,
            firstStop.pos.lng,
            d.pos.lat,
            d.pos.lng
          );
        }
      });
      fun.sortObjects(filtered, "mileage");
      return filtered;
    },
    sortMapData() {
      if (!this.curAgent) {
        return;
      }
      var whs = this.mapData.filter((m) => {
        return m.warehouseId;
      });
      var stops = [];
      var agent = this.agent.filter((a) => {
        return a._id == this.curAgent._id;
      });
      var agentPos = fun.deepFind(agent[0], "address.address.geo.position");
      var agentMarker = {
        label: agent[0].company,
        shortLabel: '<div class="mdi mdi-worker"></div>',
        pos: {
          lat: agentPos[0],
          lng: agentPos[1],
        },
        address: fun.deepFind(agent[0], "address.address.address"),

        markerColor: "red",
      };
      // var mData = [];
      stops.push(agentMarker);
      // mData.concat(this.mapData)
      // var seq = this.getSequence(this.mapData, agentMarker, "!r.warehouseId");
      var stopsData = this.mapData.filter((m) => {
        return !m.warehouseId && m.whs;
      });
      var firstStop = this.getSequence(stopsData, agentMarker)[0];
      whs.forEach((w) => {
        var nextSeq = this.getSequence(
          stopsData,
          firstStop,
          "r.whs._id=='" + firstStop.whs._id + "'"
        );
        stops = stops.concat(nextSeq);
        var lastWhs = whs.filter((f) => {
          return f.warehouseId == firstStop.whs._id;
        })[0];

        stops.push(lastWhs);
        firstStop = this.getSequence(
          stopsData,
          lastWhs,
          "r.whs._id!='" + lastWhs.warehouseId + "'"
        )[0];
      });

      stops.forEach((s, i) => {
        s.stop_order = i;
      });
      this.mapData = stops;
      // this.mapData.forEach((m) => {
      //   m.shortLabel = m.stop_order;
      // });
    },
    getTripDefaultModel() {
      this.defaultModel = {
        _id: fun.guid(),
        orig_warehouse: this.curWhs,
        status: "scheduled",
        haul_type: "internal",
      };
      this.mapLegend.defaultModel = this.defaultModel;
      return this.defaultModel;
    },
    calendarFilter(c) {
      c.events = c.originalEvents.filter((e) => {
        return this.curAgent
          ? e.itinerary &&
              e.itinerary.length &&
              e.itinerary[0].agent &&
              e.itinerary[0].agent._id == this.curAgent._id
          : true;
      });
    },
  },
  watch: {
    activeTab() {
      if (!this.activeTab) {
        this.tableReady = false;
        // this.calKey = !this.calKey;
      } else {
        // this.getQry();
        if (this.dispatchType == "ld_pickup") {
          this.filterData(this.curAgent, true);
        }
      }
    },
    sitDate() {
      if (!this.activeTab) {
        this.calKey = !this.calKey;
      } else {
        this.getQry();
      }
    },
    curAgent: function(v) {
      this.filterData(v);
    },

    tripDrawer: function() {
      // this.noDelete = !this.tripDrawer;
      if (this.tbl) {
        this.tbl.select = this.selectedTrip && this.selectedTrip.length;
      }

      this.getTripDefaultModel();
    },
    e1: function() {
      if (this.e1 == 2) {
        var tripJob = this.getSelectedJobs();
        // this.calculateRoute(tripJob, r => {

        this.defaultTripModel = {
          orig_warehouse: this.curWhs,
          status: "scheduled",
          trip_job: tripJob,
        };

        this.tripTableKey = !this.tripTableKey;
        // })
      }
    },
    curWhs: function(v) {
      this.filterData(v);
      this.getTripDefaultModel();
      // var mapShown = this.activeTab == 2;
      // if (mapShown) {
      //   this.activeTab = 1;

      //   setTimeout((f) => {
      //     if (mapShown) {
      //       this.activeTab = 2;
      //     }
      //   }, 10);
      //   // } else {
      // }
    },
    etaDateRange: function() {
      this.dateFilter("eta");
    },
    etdDateRange: function() {
      this.dateFilter("etd");
    },
    dispatchType: function() {
      this.tableKey = !this.tableKey;
    },
    serviceDate: function() {
      this.getQry(this.serviceDate);
    },
    $route: function() {
      switch (this.$route.params.id) {
        case "ld-pickup":
          if (this.mapLegend) {
            this.mapLegend.width = 2;
          }
          if (this.curAgent) {
            this.filterData(this.curAgent);
          }

          break;
        case "warehouse":
          if (this.mapLegend) {
            this.mapLegend.width = 2;
          }
          this.initWarehouse(true);
          if (this.curWhs._id) {
            this.filterData(this.curWhs);
            this.getTripDefaultModel();
          }

          break;

        case "trips":
          if (this.mapLegend) {
            this.mapLegend.width = 4;
          }
          this.createTripMapData();
          break;

        default:
          break;
      }

      this.mapData = [];
      if (this.mapLegend) {
        if (this.dispatchType == "trip") {
          this.mapLegend.width = 4;
        } else {
          this.mapLegend.width = 2;
        }
      }
      // this.mapKey = !this.mapKey;
    },
  },
};
</script>
<style lang="css">
.v-navigation-drawer__content {
  /* background-color: rgb(240, 242, 243) !important; */
  border: none !important;
}

.v-stepper__wrapper {
  height: calc(100vh - 300px) !important;
  position: relative !important;
}

.v-stepper__content {
  background-color: rgb(240, 242, 243) !important;
}

.navigation-drawer__border {
  display: none !important;
  width: 0 !important;
}

.stepper_nav {
  position: absolute;
  width: 100%;
  height: 50px;
  padding: 10px;
  bottom: 0px;
  /* background-color: antiquewhite; */
}

/* .right-drawer {
  background-color: antiquewhite;
} */
</style>
